module.exports = __webpack_public_path__ + "img/suspended_point.0422c839.jpg";